/* eslint-disable max-classes-per-file */

import { CONCEPTS } from '@rover/rsdk/src/concepts';
import type { ConsentPurpose } from '@rover/rsdk/src/modules/Analytics';
import { AnalyticsEvent } from '@rover/types/src/Analytics';

/**
 * &nbsp;
 *
 * # Description
 *
 * Fires'sitter-profile-price-disclaimer-shown' when SitterPriceBanner is rendered
 *
 * &nbsp;
 */
export class SitterProfilePriceDisclaimerShownEvent extends AnalyticsEvent {
  eventName = 'sitter-profile-price-disclaimer-shown';

  consentPurpose: ConsentPurpose = 'functional';

  concept = CONCEPTS.recommendations.browse_search;
}

/**
 * &nbsp;
 *
 * # Description
 *
 * Fires when a person clicks the "booking fee" link on search header on the
 * sitter profile page in web/mweb
 *
 * &nbsp;
 */
export class BookingFeeLinkClickProfileEvent extends AnalyticsEvent {
  eventName = 'booking-fee-link-click-profile';

  consentPurpose: ConsentPurpose = 'functional';

  concept = CONCEPTS.recommendations.browse_search;
}

/**
 * &nbsp;
 *
 * # Description
 *
 * Fires when a person clicks the "booking fee" link on search header on the CMS page
 * in web/mweb
 *
 * &nbsp;
 */
export class BookingFeeLinkClickCMSEvent extends AnalyticsEvent {
  eventName = 'booking-fee-link-click-cms';

  consentPurpose: ConsentPurpose = 'functional';

  concept = CONCEPTS.recommendations.browse_search;
}

export class BookingFeeLearnMoreHelpCenterEvent extends AnalyticsEvent {
  eventName = 'booking-fee-learn-more-help-center';

  consentPurpose: ConsentPurpose = 'functional';

  concept = CONCEPTS.recommendations.browse_search;
}
